import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations";
import { OmegakeittiotPurchaseRequestDataGridActionBarComponents } from "./OmegakeittiotPurchaseRequestDataGridActionBarComponents";

export const omegakeittiotCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
		},
	},
	purchaseRequestsDataGridActionBarComponents:
		OmegakeittiotPurchaseRequestDataGridActionBarComponents,
} as const;
